import { CategoryType } from "@/types/business/category.type";

export class Category {
  category: string = "";
  color: string = "";
  created_at: string = "";
  id: string = "";
  image?: string = "";
  local_name?: string = "";
  name: string = "";
  salable: boolean = false;
  tax?: number = 0;
  updated_at: string = "";

  constructor(data: CategoryType) {
    Object.assign(this, data);
  }
}
